export enum WatchThemeStatus {
  AVAILABLE = 'Available',
  PENDING_BUILD = 'Pending Build',
  RETIRED = 'Retired',
}

export interface DesignBrief {
  fileName: string;
  kind: string;
  displayType: string;
  sizeLabel: string;
  attachedBy?: string;
  attachedAt?: string;
  url?: string;
  content?: string;
}

export interface WatchTheme {
  id: string;
  uniqueKey: string;
  name: string;
  description?: string;
  status: WatchThemeStatus | string;
  watchAppVersion?: string | null;
  designBrief?: DesignBrief | null;
  organizationCount: number;
  lastUpdated?: string;
  updatedAt?: string;
  updatedBy?: {
    name?: string;
  };
  isDefault?: boolean;
}
